import React, { useState } from "react";
import { calcEarnings, nairaFormat } from "@/lib/api";
import { Slider } from "@/components/ui/slider";

export default function EarningsCalculator({ compact = false }) {
  const [followers, setFollowers] = useState(10000);
  const { gross, creative, agency } = calcEarnings(followers);

  return (
    <div
      data-testid="earnings-calculator"
      className={`tracing-border ${compact ? "p-6" : "p-8 md:p-12"} glow-pulse`}
    >
      <div className="flex items-center gap-3 mb-6">
        <span className="font-mono-jb text-[10px] uppercase tracking-[0.2em] text-[#00E676]">
          //  Earnings Calculator
        </span>
        <div className="flex-1 h-px bg-[#122E1C]" />
        <span className="font-mono-jb text-[10px] text-[#8A9F90]">1,000 followers = ₦500</span>
      </div>

      <div className="grid md:grid-cols-2 gap-8 items-start">
        <div>
          <label htmlFor="followers-input" className="text-xs uppercase tracking-widest text-[#8A9F90] font-mono-jb">
            Type your combined followers
          </label>
          <div className="mt-2 border-2 border-[#00E676]/40 focus-within:border-[#00E676] bg-[#030A06] p-3 transition-colors">
            <input
              id="followers-input"
              data-testid="earnings-followers-input"
              type="number"
              min={0}
              max={5000000}
              inputMode="numeric"
              pattern="[0-9]*"
              placeholder="e.g. 25000"
              value={followers || ""}
              onChange={(e) => setFollowers(Math.max(0, Math.min(5000000, Math.floor(Number(e.target.value) || 0))))}
              className="w-full bg-transparent outline-none font-display text-4xl md:text-5xl text-white placeholder:text-[#0D2114]"
            />
          </div>
          <div className="text-[10px] text-[#8A9F90] font-mono-jb mt-2">Tip: add up your TikTok + Instagram + X + YouTube + Facebook followers</div>
          <div className="mt-5">
            <div className="text-[10px] uppercase tracking-widest text-[#8A9F90] font-mono-jb mb-2">…or drag</div>
            <Slider
              data-testid="earnings-followers-slider"
              value={[Math.min(followers, 5000000)]}
              max={5000000}
              step={5000}
              onValueChange={(v) => setFollowers(v[0])}
              className="[&_[role=slider]]:bg-[#00E676] [&_[role=slider]]:border-[#00E676]"
            />
            <div className="flex justify-between text-[10px] text-[#8A9F90] mt-2 font-mono-jb">
              <span>0</span><span>500K</span><span>1M</span><span>2.5M</span><span>5M+</span>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <div className="border border-[#122E1C] p-5 bg-[#07140B]">
            <div className="text-[10px] uppercase tracking-[0.2em] text-[#8A9F90] font-mono-jb">Gross gig value</div>
            <div data-testid="earnings-gross" className="font-mono-jb text-3xl md:text-4xl text-white mt-1">{nairaFormat(gross)}</div>
          </div>
          <div className="border border-[#00E676]/50 p-5 bg-[#0D2114]">
            <div className="text-[10px] uppercase tracking-[0.2em] text-[#00E676] font-mono-jb">You take home · 80%</div>
            <div data-testid="earnings-creative" className="font-mono-jb text-4xl md:text-5xl text-[#00E676] mt-1 font-bold">{nairaFormat(creative)}</div>
          </div>
          <div className="border border-[#122E1C] p-5 bg-[#07140B] flex items-center justify-between">
            <div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-[#8A9F90] font-mono-jb">Nasarawa Expo · 20%</div>
              <div className="text-xs text-[#8A9F90] mt-1">Vetting · Client mgmt · Payouts</div>
            </div>
            <div data-testid="earnings-agency" className="font-mono-jb text-2xl text-[#F4B41A]">{nairaFormat(agency)}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
